import { render, staticRenderFns } from "./TicketGrid.vue?vue&type=template&id=4c0c6356&"
import script from "./TicketGrid.vue?vue&type=script&lang=js&"
export * from "./TicketGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports